import Vue from "vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import config from "./app.config.js";
import axios from "./plugins/axios";
import async from "async";
import "./registerServiceWorker";

Vue.config.productionTip = false;
Vue.prototype.Document = window.document;
Vue.use(axios);

new Vue({
  store,
  vuetify,
  axios,
  config,
  async,
  router,
}).$mount("#app");
